import { MapBuilder, px, type Decor, type MapDef } from '../mapdef';

/**
 * The family's balcony garden: red quarry tiles, three planters (the 3×3 plots), a tap,
 * the washing machine and the laundry rack. Rows 0–1 and the edges are the railing with
 * the rooftops behind it (painted by the `fam_view` / `fam_railS` decor).
 */
const W = 16, H = 11;
const b = new MapBuilder(W, H, 'O');
b.fill(1, 2, W - 2, H - 3, ',');
b.fill(0, 0, 1, H, '#');
b.set(0, 3, 'D');

const box = (tx: number, ty: number, tw: number, th: number) => ({ x: px(tx) + 1, y: px(ty) + 1, w: px(tw) - 2, h: px(th) - 2 });

const decor: Decor[] = [
  // Far view, back railing and side railing (drawn behind everything).
  { kind: 'fam_view', x: px(W / 2), y: px(2) - 1, w: px(W) + 200 },
  // Front railing and the facade below (drawn in front of everything).
  { kind: 'fam_railS', x: px(W / 2), y: px(H - 1) + 6, w: px(W) + 200 },
  { kind: 'fam_laundry', x: px(12) + 8, y: px(3) - 2, w: px(5), solid: { x: px(10) + 4, y: px(3) - 7, w: px(5) - 8, h: 5 } },
  { kind: 'fam_washer', x: px(2), y: px(10) - 1, w: px(2), solid: box(1, 8, 2, 2) },
  { kind: 'fam_pots', x: px(13) + 8, y: px(10) - 2, w: px(3), solid: { x: px(12) + 2, y: px(9) + 4, w: px(3) - 4, h: 10 } },
  { kind: 'fam_stool', x: px(13) + 8, y: px(6) + 12, solid: { x: px(13) + 3, y: px(6) + 6, w: 10, h: 6 } },
  { kind: 'fam_herb', x: px(1) + 8, y: px(2) + 14, solid: { x: px(1) + 2, y: px(2) + 6, w: 12, h: 8 } },
];

export const balcony: MapDef = {
  id: 'balcony',
  w: b.w,
  h: b.h,
  rows: b.rows(),
  indoor: false,
  theme: { wallFace: '#e9dcc3', wallLight: '#f6ecd8', wainscot: '#8a5c3a', wallTop: '#4a3a30' },
  doors: [{ tiles: [[0, 3]], to: 'home', arrive: { x: px(22), y: px(12), facing: 'left' } }],
  decor,
  areas: [{ key: 'balcony', rect: { x: 0, y: 0, w: px(W), h: px(H) } }],
  lights: [
    { x: px(1) + 4, y: px(2) + 4, r: 70, color: '255,214,150' },
    { x: px(8), y: px(6), r: 110, color: '255,226,180' },
  ],
};
